export const networking = {
  'QrBadge': 'QR Badge',
  'seeAll': 'Alle anzeigen',
  'newcommers': 'New Networkers',
  'checkThemOut': 'Schau sie dir an!',
  'topicsToDiscuss': 'Themen zu besprechen',
  'OneOnOneMeet': '1:1 Treffen',
  'learnMoreNetworking': 'Mehr über Networking Hub erfahren',
  'scanQrCode': 'QR-Code scannen',
  'myBadge': 'Mein Badge',
  'message': 'Nachricht',
  'scannedBadge': 'Gescanntes Badge',
  'viewProfile': 'Profil anzeigen',
  'userRatingDetails': 'Benutzerbewertung Details',
  'networkingHub': 'Networking Hub',
  'totalScore': 'Gesamtpunktzahl:',
  'scoreComposedOf': 'Dieser Punktestand setzt sich zusammen aus:',
  'confirmationText': 'Bist du sicher? Dies kann nicht rückgängig gemacht werden.',

  'welcomeMessage': 'Willkommen im <strong>Networking Hub</strong>, wo Verbindungen zum Leben erwachen! So funktioniert es:',
  'connectingMadeSimpleTitle': 'Verbindung leicht gemacht',
  'connectingMadeSimpleDescription':
    'Der Networking Hub bietet strukturierte Aktivitäten und Levels, um dir zu helfen, effektiv zu vernetzen:',

  'newcomersDescription':
    '<strong>Newcomers:</strong> Durchstöbere die Profile der Neulinge, füge interessante Personen zu deiner Shortlist hinzu und sende ihnen Nachrichten. Du kannst dich auch persönlich mit ihnen verbinden.',
  'shortlistDescription':
    '<strong>Shortlist:</strong> Sobald du Interesse an jemandem zeigst, wird er zu deiner Shortlist hinzugefügt.',
  'contactedConnectedDescription':
    '<strong>Contacted/Connected:</strong> Wenn du jemanden kontaktierst und eine Antwort erhältst, verschiebt sich diese Person in diese Kategorie.',
  'skipDescription': '<strong>Skip:</strong> Kein Interesse? Einfach das Profil überspringen und weitermachen!',

  'enhancedNetworkingActivitiesTitle': 'Erweiterte Networking-Aktivitäten',
  'enhancedNetworkingActivitiesDescription': 'Neben direkten Verbindungen umfasst der Hub:',

  'topicsToDiscussDescription':
    '<strong>Topics to Discuss:</strong> Entdecke Themen, die dich interessieren, und verbinde dich mit den Autoren oder Teilnehmern. Nimm an Online-Diskussionen teil oder plane Gruppentreffen, um diese Themen weiter zu vertiefen.',
  'oneOnOneMeetingPlannerDescription':
    '<strong>1:1 Meeting Planner:</strong> Verwalte Meeting-Anfragen, verfolge geplante Meetings und organisiere deinen Zeitplan mühelos.',

  'gamificationTitle': 'Gamification für Spaß und Engagement',
  'gamificationDescription':
    'Steigere deine Aktivität mit einem Leaderboard, das deine Punkte verfolgt und die aktivsten Networker anzeigt. So kannst du Punkte sammeln:',

  'pointsSystem': {
    points1000ProfileComplete: '<strong>1.000 Punkte:</strong> Vervollständige dein Profil (einschließlich eines Fotos).',
    points1000PushNotifications: '<strong>1.000 Punkte:</strong> Aktiviere Push-Benachrichtigungen.',
    points100SendMeetingRequest: '<strong>100 Punkte:</strong> Sende eine 1:1 Meeting-Anfrage.',
    points400GetAcceptedRequest: '<strong>400 Punkte:</strong> Lass deine 1:1 Anfrage akzeptieren.',
    points400AcceptRequest: '<strong>400 Punkte:</strong> Akzeptiere eine 1:1 Anfrage.',
    points100DeclineRequest: '<strong>100 Punkte:</strong> Lehne eine 1:1 Anfrage ab.',
    points400CreateDiscussion: '<strong>400 Punkte:</strong> Erstelle ein Diskussionsthema.',
    points50LikeDiscussion: '<strong>50 Punkte:</strong> Like ein Diskussionsthema.',
    points200PostFirstComment:
      '<strong>200 Punkte:</strong> Jedes Mal, wenn du deinen ersten Kommentar zu einem anderen Thema postest.',
    points100LikeOnTopic: '<strong>100 Punkte:</strong> Erhalte ein Like zu deinem Thema.',
    points200UniqueCommenter: '<strong>200 Punkte:</strong> Erhalte einen einzigartigen Kommentator zu deinem Thema.',
    points100LikeShortlistUser: '<strong>100 Punkte:</strong> Like/füge einen Benutzer zu deiner Shortlist hinzu.',
    points50SkipUser: '<strong>50 Punkte:</strong> Überspringe einen Benutzer.',
    points200StartChat: '<strong>200 Punkte:</strong> Starte einen Chat (kontaktiert).',
    points300GetChatResponse: '<strong>300 Punkte:</strong> Erhalte eine Antwort in einem Chat (verbunden).',
    points400RespondToChat: '<strong>400 Punkte:</strong> Antworte auf eine Chat-Anfrage (verbunden).',
    points500SpeedNetworking: '<strong>500 Punkte:</strong> Für jede Speed-Networking-Sitzung.'
  },

  'finalMessage':
    'Nutze das Beste aus dem Networking Hub, entdecke neue Möglichkeiten und steig auf das Leaderboard, während du dich mit gleichgesinnten Fachleuten verbindest und engagierst!',

  'manageMeeting': 'Meeting verwalten',
  'addToCalendar': 'Zum Kalender hinzufügen',
  'cancel': 'Abbrechen',
  'accept': 'Akzeptieren',
  'accept&addToCalendar': 'Akzeptieren und zum Kalender hinzufügen',
  'editDetails': 'Details bearbeiten',
  'reject': 'Ablehnen',
  'delete': 'Löschen',
  'exportContact': 'Kontakt exportieren',
  'scheduleNewOneOnOne': 'Neues 1:1 planen',
  'initiatedBy': 'Initiiert von',
  'rejectedBy': 'Abgelehnt von',
  'you': 'du',
  'meetPassed': 'Das Meeting ist vorbei',
  'meetInProgress': 'Läuft',

  'myOneOnOne': 'Mein 1:1',

  'speed': {
    history: 'Verlauf',
    minutes: 'Min.',
    users_available: 'verfügbare',
    rules: 'Regeln',
    activate: 'Aktivieren',
    matching: 'Matching...',
    start: 'Start',
    find_a_user: 'Finde einen Benutzer mit demselben Bild',
    find_a_user_number: 'Finde einen Benutzer mit derselben Nummer',
    waiting: 'Warten...',
    speaking_now: 'Spricht jetzt',
    networking_topics: 'Networking-Themen',
    session_ended: 'Sitzung beendet',
    find_next_partner: 'Nächsten Partner finden',
    find_next_group: 'Nächste Gruppe finden',
    partner_wasnt_ready: 'Partner war nicht bereit',
    partner_wasnt_ready_description:
      'Es scheint, dass der Partner nicht bereit für die Diskussion war. Lassen Sie uns einen neuen finden!',
    start_matching: 'Matching starten'
  }
}
